import { Link, useLocation } from "react-router-dom";
import { Languages } from "lucide-react";
import Logo from "./Logo";
import { useT, useLocalePath, useLocale, pathInOtherLocale } from "../i18n/useT";

export default function Header() {
  const t = useT();
  const localePath = useLocalePath();
  const locale = useLocale();
  const { pathname } = useLocation();
  const onHome = pathname === "/" || pathname === "/es";

  const links = [
    { hash: "services", label: t.nav.services },
    { hash: "expertise", label: t.nav.expertise },
    { hash: "how", label: t.nav.howWeWork },
    { route: "/insights", label: t.nav.insights },
    { hash: "contact", label: t.nav.contact },
  ];

  const otherLocalePath = pathInOtherLocale(pathname);
  const otherLocaleLabel = locale === "es" ? "EN" : "ES";

  return (
    <header className="sticky top-0 z-30 border-b border-ink-800/60 bg-ink-950/80 backdrop-blur">
      <div className="container-page flex h-16 items-center justify-between gap-4">
        <Link to={localePath("/")} aria-label="SV4-tech home">
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-7 text-sm text-ink-300">
          {links.map((l) =>
            "hash" in l && l.hash ? (
              onHome ? (
                <a key={l.hash} href={`#${l.hash}`} className="hover:text-ink-50 transition">
                  {l.label}
                </a>
              ) : (
                <Link
                  key={l.hash}
                  to={`${localePath("/")}${localePath("/").endsWith("/") ? "" : ""}#${l.hash}`}
                  className="hover:text-ink-50 transition"
                >
                  {l.label}
                </Link>
              )
            ) : (
              <Link
                key={l.route}
                to={localePath(l.route!)}
                className="hover:text-ink-50 transition"
              >
                {l.label}
              </Link>
            ),
          )}
        </nav>
        <div className="flex items-center gap-2">
          <Link
            to={otherLocalePath}
            className="inline-flex items-center gap-1 rounded-md border border-ink-700 px-2 py-1 text-xs font-medium text-ink-300 hover:border-ink-500 hover:text-ink-50 transition"
            aria-label={t.language.switchTo}
            title={t.language.switchTo}
          >
            <Languages className="size-3.5" />
            {otherLocaleLabel}
          </Link>
          <Link
            to={onHome ? `${pathname}#contact` : localePath("/#contact")}
            className="btn-primary text-xs px-4 py-2 hidden sm:inline-flex"
          >
            {t.nav.bookACall}
          </Link>
        </div>
      </div>
    </header>
  );
}
